import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/RequestPackageProposalPptx.graphql';
import { Mutation, MutationrequestPackageProposalPptxArgs } from '../../__generated__/globalTypes';

export const useRequestPackageProposalPptxMutation = (
  options?: MutationHookOptions<Mutation, MutationrequestPackageProposalPptxArgs>
) => {
  const [callRequestPackageProposalPptx, result] = useMutation<Mutation, MutationrequestPackageProposalPptxArgs>(
    MUTATION,
    options
  );

  return { callRequestPackageProposalPptx, ...result };
};

export type RequestPackageProposalPptxMutationFunction = Mutation['requestPackageProposalPptx'];
